import React, { useContext } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

const FilterFormInfo = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { getFilterInfo } = rootStore.trackDocumentStore;

  return (
    <div      
      dangerouslySetInnerHTML={{ __html: getFilterInfo() }}
    ></div>
  );
};

export default FilterFormInfo;
